/**
 * Faith Shop — Shopify Theme JavaScript
 * All interactive features: slider, cart, menu, search, variants, size guide
 */

document.addEventListener('DOMContentLoaded', function() {

  /* ============================================
     HEADER — Scroll behavior
     ============================================ */
  var header = document.querySelector('[data-header]');
  var backToTop = document.querySelector('[data-back-to-top]');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
      if (backToTop) backToTop.classList.toggle('is-visible', window.scrollY > 400);
    });
  }
  if (backToTop) {
    backToTop.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ============================================
     LOCALE SELECTOR DROPDOWN
     ============================================ */
  var localeToggle = document.querySelector('[data-locale-toggle]');
  var localeDropdown = document.querySelector('[data-locale-dropdown]');
  if (localeToggle && localeDropdown) {
    localeToggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var isOpen = localeDropdown.classList.toggle('is-open');
      localeToggle.setAttribute('aria-expanded', isOpen);
    });
    document.addEventListener('click', function(e) {
      if (!e.target.closest('[data-localization]')) {
        localeDropdown.classList.remove('is-open');
        localeToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ============================================
     MOBILE MENU — premium drawer
     ============================================ */
  var mobileMenu = document.getElementById('mobile-menu');

  if (mobileMenu) {
    var mobilePanel = mobileMenu.querySelector('.mobile-menu__panel');
    var mobileOpenButtons = document.querySelectorAll('[data-mobile-menu-open]');
    var mobileCloseButtons = mobileMenu.querySelectorAll('[data-mobile-menu-close]');
    var lastFocusedElement = null;

    function getMobileFocusableElements() {
      if (!mobilePanel) return [];

      return Array.prototype.slice.call(
        mobilePanel.querySelectorAll(
          'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter(function(element) {
        return element.offsetParent !== null;
      });
    }

    function openMobileMenu(trigger) {
      lastFocusedElement = trigger || document.activeElement;

      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mobile-menu-open');

      mobileOpenButtons.forEach(function(button) {
        button.setAttribute('aria-expanded', 'true');
      });

      window.setTimeout(function() {
        var focusable = getMobileFocusableElements();

        if (focusable.length) {
          focusable[0].focus();
        }
      }, 320);
    }

    function closeMobileMenu(options) {
      var settings = options || {};

      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mobile-menu-open');

      mobileOpenButtons.forEach(function(button) {
        button.setAttribute('aria-expanded', 'false');
      });

      if (settings.restoreFocus !== false && lastFocusedElement) {
        lastFocusedElement.focus();
      }
    }

    mobileOpenButtons.forEach(function(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        openMobileMenu(button);
      });
    });

    mobileCloseButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        closeMobileMenu();
      });
    });

    mobileMenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        closeMobileMenu({ restoreFocus: false });
      });
    });

    mobileMenu.querySelectorAll('[data-cart-open]').forEach(function(button) {
      button.addEventListener('click', function() {
        closeMobileMenu({ restoreFocus: false });
      });
    });

    document.addEventListener('keydown', function(event) {
      if (!mobileMenu.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeMobileMenu();
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = getMobileFocusableElements();

      if (!focusable.length) {
        event.preventDefault();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  /* ============================================
     SEARCH OVERLAY
     ============================================ */
  var searchOverlay = document.getElementById('search-overlay');
  if (searchOverlay) {
    document.querySelectorAll('[data-search-open]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        searchOverlay.classList.add('is-open');
        var input = searchOverlay.querySelector('[data-search-input]');
        if (input) setTimeout(function() { input.focus(); }, 200);
      });
    });
    document.querySelectorAll('[data-search-close]').forEach(function(btn) {
      btn.addEventListener('click', function() { searchOverlay.classList.remove('is-open'); });
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchOverlay.classList.contains('is-open')) {
        searchOverlay.classList.remove('is-open');
      }
    });
  }

  /* ============================================
     CART DRAWER
     ============================================ */
  var cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer) {
    document.querySelectorAll('[data-cart-open]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        cartDrawer.classList.add('is-open');
      });
    });
    document.querySelectorAll('[data-cart-close]').forEach(function(btn) {
      btn.addEventListener('click', function() { cartDrawer.classList.remove('is-open'); });
    });

    cartDrawer.addEventListener('click', function(e) {
      var qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        var key = qtyBtn.getAttribute('data-qty-change');
        var direction = qtyBtn.getAttribute('data-direction');
        var valueEl = qtyBtn.parentElement.querySelector('.cart-item__qty-value');
        var currentQty = parseInt(valueEl.textContent);
        var newQty = direction === 'up' ? currentQty + 1 : Math.max(0, currentQty - 1);
        updateCart(key, newQty);
      }
      var removeBtn = e.target.closest('[data-remove-item]');
      if (removeBtn) {
        updateCart(removeBtn.getAttribute('data-remove-item'), 0);
      }
    });
  }

  function updateCart(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function() { location.reload(); });
  }

  /* ============================================
     THEME TOGGLE
     ============================================ */
  document.querySelectorAll('[data-theme-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var html = document.documentElement;
      html.classList.add('theme-transition');
      html.classList.toggle('dark');
      localStorage.setItem('faith-theme', html.classList.contains('dark') ? 'dark' : 'light');
      setTimeout(function() { html.classList.remove('theme-transition'); }, 400);
    });
  });

  /* ============================================
     PROMO BANNER
     ============================================ */
  var promoBanner = document.querySelector('[data-promo-banner]');
  if (promoBanner) {
    var promoClose = promoBanner.querySelector('[data-promo-close]');
    if (promoClose) {
      promoClose.addEventListener('click', function() {
        promoBanner.classList.add('is-hidden');
        if (header) header.style.top = '0';
      });
    }
    if (header && !promoBanner.classList.contains('is-hidden')) {
      header.style.top = promoBanner.offsetHeight + 'px';
    }
  }

  /* ============================================
     HERO SLIDER
     ============================================ */
  var heroSlider = document.getElementById('hero-slider');
  if (heroSlider) {
    var slides = heroSlider.querySelectorAll('[data-slide]');
    var dots = heroSlider.querySelectorAll('[data-dot]');
    var slideCount = slides.length;
    var current = 0;
    var timer = null;

    if (slideCount > 1) {
      function goTo(index) {
        slides.forEach(function(s, i) { s.classList.toggle('is-active', i === index); });
        dots.forEach(function(d, i) { d.classList.toggle('is-active', i === index); });
        current = index;
      }
      function nextSlide() { goTo((current + 1) % slideCount); }
      function resetTimer() { if (timer) clearInterval(timer); timer = setInterval(nextSlide, 6000); }

      heroSlider.addEventListener('click', function(e) {
        var dot = e.target.closest('[data-dot]');
        if (dot) { goTo(parseInt(dot.getAttribute('data-dot'))); resetTimer(); return; }
        var nav = e.target.closest('[data-nav]');
        if (nav) {
          if (nav.getAttribute('data-nav') === 'prev') goTo(current === 0 ? slideCount - 1 : current - 1);
          else nextSlide();
          resetTimer();
        }
      });

      var touchStartX = 0;
      heroSlider.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
      heroSlider.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) nextSlide(); else goTo(current === 0 ? slideCount - 1 : current - 1);
          resetTimer();
        }
      }, { passive: true });

      timer = setInterval(nextSlide, 6000);
    }
  }

  /* ============================================
     PRODUCT GALLERY
     ============================================ */
  var gallery = document.getElementById('product-main-image');
  var showMedia = null; // expose for variant switching
  if (gallery) {
    var mediaSlides = gallery.querySelectorAll('[data-media-index]');
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    var galDots = gallery.querySelectorAll('[data-gallery-dot]');
    var mediaCount = mediaSlides.length;
    var mediaCurrent = 0;

    showMedia = function(index) {
      if (index < 0 || index >= mediaCount) return;
      // Pause all videos when switching slides
      mediaSlides.forEach(function(s, i) {
        s.classList.toggle('is-active', i === index);
        var video = s.querySelector('video');
        if (video && i !== index) video.pause();
      });
      thumbs.forEach(function(t, i) { t.classList.toggle('is-active', i === index); });
      galDots.forEach(function(d, i) { d.classList.toggle('is-active', i === index); });
      mediaCurrent = index;
    };

    gallery.addEventListener('click', function(e) {
      if (e.target.closest('[data-gallery-prev]')) showMedia(mediaCurrent === 0 ? mediaCount - 1 : mediaCurrent - 1);
      if (e.target.closest('[data-gallery-next]')) showMedia((mediaCurrent + 1) % mediaCount);
      var dot = e.target.closest('[data-gallery-dot]');
      if (dot) showMedia(parseInt(dot.getAttribute('data-gallery-dot')));
    });

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        showMedia(parseInt(thumb.getAttribute('data-gallery-thumb')));
      });
    });
  }

  /* ============================================
     SIZE GUIDE MODAL
     ============================================ */
  var sizeGuide = document.getElementById('size-guide-modal');
  if (sizeGuide) {
    document.querySelectorAll('[data-size-guide-open]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        sizeGuide.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    });
    document.querySelectorAll('[data-size-guide-close]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        sizeGuide.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
    // Close on ESC
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && sizeGuide.classList.contains('is-open')) {
        sizeGuide.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  /* ============================================
     PRODUCT VARIANT SWITCHING
     ============================================ */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var productJsonEl = document.querySelector('[data-product-json]');
    if (productJsonEl) {
      var productData;
      try {
        productData = JSON.parse(productJsonEl.textContent);
      } catch(e) {
        console.error('Invalid product JSON');
        return;
      }

      var variantIdInput = productForm.querySelector('[data-variant-id]');
      var selectedOptions = {};

      // Initialize selected options from first available variant
      if (productData.selected_or_first_available_variant) {
        productData.options.forEach(function(opt, i) {
          selectedOptions[i] = productData.selected_or_first_available_variant.options[i];
        });
      }

      // Listen for clicks on option buttons (sizes, colors, etc.)
      productForm.addEventListener('click', function(e) {
        var optionBtn = e.target.closest('[data-option-index]');
        if (!optionBtn || optionBtn.disabled) return;

        e.preventDefault();

        var index = parseInt(optionBtn.getAttribute('data-option-index'));
        var value = optionBtn.getAttribute('data-value');

        // Update UI — deselect siblings, select this one
        var siblings = optionBtn.parentElement.querySelectorAll('[data-option-index="' + index + '"]');
        siblings.forEach(function(b) { b.classList.remove('is-selected'); });
        optionBtn.classList.add('is-selected');

        // Update label text
        var label = optionBtn.closest('.product-form__option');
        if (label) {
          var strong = label.querySelector('.product-form__option-label strong');
          if (strong) strong.textContent = value;
        }

        selectedOptions[index] = value;

        // Find matching variant
        var matchedVariant = null;
        for (var v = 0; v < productData.variants.length; v++) {
          var variant = productData.variants[v];
          var isMatch = true;
          for (var oi = 0; oi < productData.options.length; oi++) {
            if (variant.options[oi] !== selectedOptions[oi]) {
              isMatch = false;
              break;
            }
          }
          if (isMatch) { matchedVariant = variant; break; }
        }

        if (matchedVariant) {
          // Update hidden variant ID
          if (variantIdInput) variantIdInput.value = matchedVariant.id;

          // Update price display
          var priceEl = document.querySelector('[data-product-price]');
          if (priceEl) priceEl.textContent = formatMoney(matchedVariant.price);

          // Update add to cart button
          var submitBtn = productForm.querySelector('[data-add-to-cart]');
          if (submitBtn) {
            if (matchedVariant.available) {
              submitBtn.disabled = false;
              submitBtn.innerHTML = 'Ajouter au panier <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="product-form__arrow"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
            } else {
              submitBtn.disabled = true;
              submitBtn.innerHTML = 'Épuisé';
            }
          }

          // Update URL
          var url = new URL(window.location);
          url.searchParams.set('variant', matchedVariant.id);
          history.replaceState({}, '', url);

          // Switch to variant image
          if (matchedVariant.featured_image && showMedia) {
            for (var img = 0; img < productData.images.length; img++) {
              if (productData.images[img].id === matchedVariant.featured_image.id) {
                showMedia(img);
                break;
              }
            }
          }
        }
      });

      // AJAX add to cart
      productForm.addEventListener('submit', function(e) {
        e.preventDefault();

        var submitBtn = productForm.querySelector('[data-add-to-cart]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.innerHTML = '<span class="product-form__spinner"></span> Ajout en cours...';
        }

        var formData = new FormData(productForm);
        if (!formData.has('quantity')) formData.append('quantity', '1');

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(r) {
          if (!r.ok) throw new Error('Erreur ajout panier');
          return r.json();
        })
        .then(function() {
          // Update cart count
          return fetch('/cart.js');
        })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function(el) {
            el.textContent = cart.item_count;
          });

          // Refresh cart drawer content via section rendering API
          return fetch('/?sections=cart-drawer-content');
        })
        .then(function(r) { return r.json(); })
        .then(function(sections) {
          // Fallback: reload drawer body by fetching current page
          return fetch(window.location.pathname);
        })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newDrawerBody = doc.getElementById('cart-drawer-body');
          var currentDrawerBody = document.getElementById('cart-drawer-body');
          if (newDrawerBody && currentDrawerBody) {
            currentDrawerBody.innerHTML = newDrawerBody.innerHTML;
          }
          // Also update cart count from new HTML
          var newCounts = doc.querySelectorAll('[data-cart-count]');
          newCounts.forEach(function(el) {
            document.querySelectorAll('[data-cart-count]').forEach(function(target) {
              target.textContent = el.textContent;
            });
          });

          // Open cart drawer
          if (cartDrawer) cartDrawer.classList.add('is-open');
        })
        .catch(function(err) {
          console.error('Add to cart error:', err);
          alert('Erreur lors de l\'ajout au panier. Veuillez réessayer.');
        })
        .finally(function() {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = 'Ajouter au panier <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="product-form__arrow"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
          }
        });
      });
    }
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  /* ============================================
     BLOG CAROUSEL
     ============================================ */
  var blogCarousel = document.getElementById('blog-carousel');
  if (blogCarousel) {
    var track = blogCarousel.querySelector('.blog-carousel__track');
    if (track && track.children.length > 3) {
      var cardWidth = 350 + 24;
      var maxScroll = (track.children.length - 3) * cardWidth;
      var pos = 0;
      var blogTimer;

      function slideTrack(p) {
        pos = Math.max(0, Math.min(p, maxScroll));
        track.style.transform = 'translateX(-' + pos + 'px)';
      }
      function autoSlide() {
        pos += cardWidth;
        if (pos > maxScroll) pos = 0;
        slideTrack(pos);
      }

      var prev = blogCarousel.querySelector('[data-blog-nav="prev"]');
      var next = blogCarousel.querySelector('[data-blog-nav="next"]');
      if (prev) prev.addEventListener('click', function() { clearInterval(blogTimer); slideTrack(pos - cardWidth); blogTimer = setInterval(autoSlide, 5000); });
      if (next) next.addEventListener('click', function() { clearInterval(blogTimer); slideTrack(pos + cardWidth); blogTimer = setInterval(autoSlide, 5000); });
      blogTimer = setInterval(autoSlide, 5000);
    }
  }

});